import React from "react"
import styles from "./visualiser-text-box.module.css"
import { useVisualiserTextBoxViewModel } from "./VisualiserTextBox.vm"

type VisualiserTextBoxProps = {
  font?: string
  fontWeight?: string
  fontSize?: number | string
  color?: string
  lineHeight?: number
  size?: {
    width: string
    minHeight: string
    maxHeight: string
    minWidth: string
    maxWidth: string
  }
  position?: {
    top?: string
    bottom?: string
    left?: string
    right?: string
  }
  maxLength?: number
  maxLines?: number
  initialValue?: string
  userEditable?: boolean
  value?: string
  style?: React.CSSProperties
  /** Overrides the browser-default placeholder colour; any opacity comes from the colour's alpha. */
  placeholderColor?: string
  setValue: (value: string) => void
}

export const VisualiserTextBox = ({
  font = "Figtree",
  fontWeight = "normal",
  fontSize = 21,
  lineHeight = 1.2,
  size,
  position,
  color,
  maxLength,
  maxLines,
  initialValue = "Tap to edit",
  userEditable = true,
  style,
  value,
  placeholderColor,
  setValue,
}: VisualiserTextBoxProps) => {
  const vm = useVisualiserTextBoxViewModel({
    font,
    fontWeight,
    fontSize,
    lineHeight,
    size,
    position,
    maxLength,
    maxLines,
    initialValue,
    userEditable,
    value,
    color,
    style,
    placeholderColor,
    setValue,
  })

  if (!vm.userEditable) {
    return (
      <div
        ref={vm.staticRef}
        className={styles["visualiser-text-box"]}
        style={vm.textareaStyle as React.CSSProperties}
      >
        {vm.displayValue}
      </div>
    )
  }

  return (
    <textarea
      ref={vm.textareaRef}
      className={
        placeholderColor
          ? `${styles["visualiser-text-box"]} ${styles["visualiser-text-box--custom-placeholder"]}`
          : styles["visualiser-text-box"]
      }
      disabled={false}
      autoComplete="off"
      autoCorrect="off"
      spellCheck="false"
      style={vm.textareaStyle as React.CSSProperties}
      placeholder={vm.placeholder}
      value={vm.displayValue}
      onChange={vm.handleChange}
      rows={1}
    />
  )
}
